import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { post as doLogin } from 'actions/login';

import { connect } from 'react-redux';
import Login from './view';

class LoginContainer extends PureComponent {
  static getDerivedStateFromProps({ login, history }, state) {
    const loginPost = state.loginPost
      ? store.post(login, state.loginPost.id)
      : store.post();
    const { resolved } = loginPost;
    let { error } = state;

    if (resolved) {
      if (resolved.isCreatingFailed) {
        error = store.getError(resolved);
      } else if (resolved.isCreated) {
        error = null;
        history.push('/');
      }
    }

    return {
      loginPost: loginPost ? store.post(login, loginPost.id) : store.post(),
      error,
    };
  }

  static propTypes = {
    actions: PropTypes.shape({
      doLogin: PropTypes.func.isRequired,
    }).isRequired,
  };

  state = {
    loginPost: null,
    error: null,
  };

  doLogin = (username, password) => {
    const {
      loginPost: { id, current },
    } = this.state;
    const { actions } = this.props;

    if (current && current.isCreating) {
      return;
    }

    actions.doLogin(id, {
      action: 'passcode',
      username,
      password,
    });
  };

  render() {
    const { error } = this.state;

    return <Login error={error} onSubmit={this.doLogin} />;
  }
}

export default connect(
  ({ login }) => ({ login }),
  dispatch => ({
    actions: bindActionCreators({ doLogin }, dispatch),
  }),
)(LoginContainer);
